import React, { useEffect } from 'react'
import { Script } from 'gatsby'

const InsiderScript: React.FC = () => {
  useEffect(() => {
    const createInsiderTag = () => {
      if (document.getElementById('insider-script')) {
        return
      }

      const script = document.createElement('script')
      script.id = 'insider-script'
      script.src = '//vivara.api.useinsider.com/ins.js?id=10007082'
      script.async = true
      script.type = 'text/javascript'
      document.head.appendChild(script)

      const hasReinitialized = sessionStorage.getItem('insiderReinitialized')

      if (
        !hasReinitialized &&
        window?.insider_object?.user?.email
      ) {
        window?.Insider?.eventManager?.dispatch('init-manager:re-initialize')
        sessionStorage.setItem('insiderReinitialized', 'true')
        console.log('[Insider] Tag reinicializada (após login)')
      }
    }

    window.addEventListener('insider-user-ready', createInsiderTag)

    return () => {
      window.removeEventListener('insider-user-ready', createInsiderTag)
    }
  }, [])

  return (
    <>
      <Script
        key="insider-listener"
        id="insider-listener"
        strategy="post-hydrate"
      >
        {`(function waitForInsider() {
          if (window.Insider?.eventManager) {
            window.Insider.eventManager.once(
              'ins-sr:only-api-campaign:load',
              function (_, data) {
                window.__insiderCampaignData = data;

                const key = 'insiderCampaignData_' + data.campaignId;
                try {
                  sessionStorage.setItem(key, JSON.stringify(data));
                } catch (e) {
                  console.warn('InsiderScript: falha ao gravar sessionStorage', e);
                }

                window.dispatchEvent(
                  new CustomEvent('insider-campaign-loaded-' + data.campaignId, {
                    detail: data,
                  })
                );

                console.log('[early listener] campanha:', data);
              }
            );
          } else {
            setTimeout(waitForInsider, 50);
          }
        })();`}
      </Script>
    </>
  )
}

export default InsiderScript
